package com.milta.core.localization.translations.fr

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Tournée",
    navEcoDriving = "Éco-conduite",
    navCommunity = "Communauté",
    navRewards = "Récompenses",
    navHome = "Accueil",
    navRoutes = "Tournées",
    navTeam = "Équipe",
    navProfile = "Profil",
)
